import { render, staticRenderFns } from "./Viber.vue?vue&type=template&id=7a7e4bee&scoped=true"
import script from "./Viber.vue?vue&type=script&lang=js"
export * from "./Viber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7e4bee",
  null
  
)

export default component.exports